import { Facility } from './../../facility';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import * as _ from 'lodash';

import { CONSTANT_VALUES } from '../../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../../constants/constants-messages';
import { AppService } from '../../../app.service';
import { FeedService } from './../../../feed/feed.service';
import { LinkService } from '../../link/link.service';
import { MessageEvent, SignInEvent, LoaderEvent, FacilityListEvent, OpenFrameEvent, SetAllMemberCheck } from './../../../shared/message.event';
import { UISETTING } from './../../../shared/ui-setting';
import { UtilityFunctions } from './../../../shared/utility-functions';

@Component({
  selector: 'app-link-broadcast',
  templateUrl: './link-broadcast.component.html',
  styleUrls: ['./link-broadcast.component.css'],
  providers: [MessageEvent, SignInEvent, LoaderEvent, FacilityListEvent, OpenFrameEvent, FeedService, SetAllMemberCheck, LinkService]
})
export class LinkBroadcastComponent implements OnInit {
  private shouldSlide: boolean = false;
  private divHeight = 30;
  private pagebutton = 30;
  private vendor: any;
  private clubName = '';
  private groupList = [];
  private createdAt: any;
  private feed: any;

  public upcomingLinks: any[] = [];
  public selectedLink: any = null;
  public selectedLinkId: string = '';
  public feedCurrentDate: string = '';

  filesToUpload: any;
  private popUpMessage: any;
  private fileUrl: any;
  private alertMessage = '';
  private alertTitle = 'Alert';

  public validationErrors: any = {
    eventError: '',
    titleError: '',
    contentError: '',
    linkError: '',
    recipientError: ''
  };

  private criteria: any;
  private onePagePerItem = 10;
  private pageOptions = { currentPage: 1, noOfPageItem: this.onePagePerItem };
  private currentPage = 1;
  private memberList = [];
  private totalSizeOfList = 0;
  private noMemberAvailable: boolean = true;

  @ViewChild('memberTable') tableVariable: any;
  @ViewChild('fileUploadInput') fileUploadInputVariable: any;
  @ViewChild('popUpObj') popUpObj: any;
  @ViewChild('backPopUpObj') backPopUpObj: any;
  @ViewChild('alertImagePopUpObj') alertImagePopUpObj: any;
  @ViewChild('ViewSelectedpopUpObj') ViewSelectedpopUpObj: any;
  @ViewChild('ViewSelectedGroupPopUpObj') ViewSelectedGroupPopUpObj: any;

  private setChecked = [];
  private isopen = false;
  private selectedCriteria = '';
  private ideal = true;
  private selectedMemberList = [];
  private selectedGroupList = [];
  private memberTableHeight = 55;
  private broadcastToList = CONSTANT_VALUES.BROADCAST_SEND_TO;
  private AddNewMemberFlag = false;
  private cancelForReset = false;
  private addGroupFlagCancel = false;
  private search = '';
  private exp = false;
  private selectNewMembers = [];
  private uiSetting: UISETTING;
  private height: any;
  private utilityFunctions = new UtilityFunctions();
  private urlErr = '';
  private allInGroup = false;

  private openSubMenu1: boolean = false;
  private openSubMenu2: boolean = false;
  private openSubMenu3: boolean = false;

  public tt = false;
  public router: Router;
  public Math = Math;
  protected popupTitle: string = 'Information';
  protected cancleButton: boolean = false;

  constructor(
    router: Router,
    private appService: AppService,
    private messageEvent: MessageEvent,
    private signInEvent: SignInEvent,
    private loaderEvent: LoaderEvent,
    private facilityListEvent: FacilityListEvent,
    private openFrameEvent: OpenFrameEvent,
    private feedService: FeedService,
    private setAllMemberCheck: SetAllMemberCheck,
    private linkService: LinkService
  ) {
    this.router = router;
    this.uiSetting = {
      'windowHeight': window.innerHeight,
      'topNav': 56,
      'midNav': 45,
      'footer': 35,
      'container': 35
    };
    this.height = 0;

    this.feed = {
      title: '',
      content: '',
      vendorId: '',
      groups: [],
      members: [],
      sendToAllMembers: false,
      file: '',
      sendOn: '',
      sendToAllGroups: false,
      broadcastLink: '',
      linkId: '',
      facilityId: '',
      linkName: '',
      linkDescription: '',
      ctaEnabled: false,
      ctaText: '',
      ctaLink: '',
      type: 'LINK_BROADCAST'
    };

    this.criteria = {
      allMember: false,
      specificMembers: false,
      allGroup: false,
      specificGroup: false
    };

    this.validationErrors = {
      eventError: '',
      titleError: '',
      contentError: '',
      linkError: '',
      recipientError: ''
    };

    this.height = (this.uiSetting.windowHeight - (this.uiSetting.topNav + this.uiSetting.midNav + this.uiSetting.container + this.uiSetting.footer + this.divHeight + this.pagebutton)) + 'px';
  }

  ngOnInit() {
    this.emitOpenFrameEvent();
    window.scrollTo(0, 0);

    try {
      this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
    } catch (e) {
      this.vendor = null;
    }
    if (this.vendor && this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors && this.vendor.subVendors.length > 0) {
        let subVendor = this.vendor.subVendors[0];
        this.clubName = subVendor.clubName;
      }
    } else {
      this.clubName = this.vendor ? this.vendor.clubName : '';
    }

    this.createdAt = moment(new Date()).format('DD/MM/YYYY');
    this.feed.vendorId = this.getVendorId();

    this.loadUpcomingLinks();
    this.getGroupListByVendor();
    this.pagination(this.pageOptions, 1);
    this.registerTypeBroadcast();
    this.emitTypeBroadcast();
  }

  private getVendorId(): string {
    if (this.vendor && this.vendor.role === CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors && this.vendor.subVendors.length > 0) {
        return this.vendor.subVendors[0]._id;
      }
    }
    return this.vendor ? this.vendor._id : '';
  }

  private parseDateCandidate(val: any): Date | null {
    if (!val) return null;
    if (val instanceof Date) return isNaN(val.getTime()) ? null : val;
    const s = val.toString();
    let d = new Date(s);
    if (!isNaN(d.getTime())) return d;
    // try fixing format like "2025-09-30 00:00:00.000" -> "2025-09-30T00:00:00.000"
    d = new Date(s.replace(' ', 'T'));
    if (!isNaN(d.getTime())) return d;
    return null;
  }

  private startOfDay(d: Date): Date {
    const t = new Date(d.getTime());
    t.setHours(0, 0, 0, 0);
    return t;
  }

  private isLinkEligible(link: any): boolean {
    if (!link) return false;

    // must be explicitly active
    if (link.isActive !== true) return false;

    const today = this.startOfDay(new Date());

    // check expiry date if present (expiryDateObj preferred)
    const expiryCandidate = link.expiryDateObj || link.expiryDate || null;
    if (expiryCandidate) {
      const e = this.parseDateCandidate(expiryCandidate);
      if (e) {
        if (this.startOfDay(e) < today) return false; // expired -> exclude
      }
      // if unparseable => keep (safer)
    }

    return true;
  }

  private loadUpcomingLinks() {
    this.loaderEvent.fire(false);
    const vendorObj = { vendorId: this.getVendorId(), showPastData:true };

    this.linkService.getLinksForVendor(vendorObj).then((result: any) => {
      try {
        if (!result || result.status !== 'SUCCESS') {
          this.upcomingLinks = [];
          this.loaderEvent.fire(true);
          return;
        }

        // === Normalization / flattening ===
        let raw: any[] = [];

        // Helper to push arrays or single-category objects
        const pushFromPossibleArrayOrCategory = (val: any) => {
          if (!val) return;
          // If it's an array of category objects (each with .data)
          if (Array.isArray(val) && val.length > 0 && val[0] && Array.isArray(val[0].data)) {
            val.forEach((cat: any) => {
              if (cat && Array.isArray(cat.data)) raw.push(...cat.data);
            });
            return;
          }
          // If it's an array of link objects (flat)
          if (Array.isArray(val)) {
            raw.push(...val);
            return;
          }
          // If it's a single category object with .data
          if (val && Array.isArray(val.data)) {
            raw.push(...val.data);
            return;
          }
          // If it's an object that *looks like* a single link, push it
          if (val && typeof val === 'object' && (val._id || val.name)) {
            raw.push(val);
            return;
          }
        };

        // 1) result.links (common)
        if (Array.isArray(result.links)) {
          pushFromPossibleArrayOrCategory(result.links);
        }

        // 2) result.linksData may be flat array, categories array, or single category object
        if (result.linksData) {
          pushFromPossibleArrayOrCategory(result.linksData);
        }

        // 3) result.facilityData similar possibilities
        if (result.facilityData) {
          pushFromPossibleArrayOrCategory(result.facilityData);
        }

        // 4) Some APIs return the category object itself as top-level result (your case)
        // e.g. result = { categoryName: 'Links', data: [ ... ] }
        if (result && Array.isArray(result.data)) {
          pushFromPossibleArrayOrCategory(result);
        }

        // 5) Fallback: if nothing collected yet, try pulling any arrays found on result
        if (raw.length === 0) {
          const maybe = result.links || result.linksData || result.facilityData;
          if (Array.isArray(maybe)) pushFromPossibleArrayOrCategory(maybe);
        }

        // Now raw should be a flat array (or empty)
        const flattened = (raw || []).filter((l: any) => !!l);

        // Filter eligible links
        this.upcomingLinks = flattened.filter(link => this.isLinkEligible(link));

      } catch (err) {
        console.error('Error processing links response', err);
        this.upcomingLinks = [];
      } finally {
        this.loaderEvent.fire(true);
      }
    }).catch((err: any) => {
      console.error('Failed to load links', err);
      this.upcomingLinks = [];
      this.loaderEvent.fire(true);
    });
  }

  /**
   * Return a readable creation date for the link
   */
  private getCreationDateFromLink(link: any): string {
    if (!link) return '';
    // prefer createdAt, fallback to link.date or dateObj
    const createdCandidate = link.createdAt || link.dateObj || link.date;
    if (!createdCandidate) return '';
    try {
      return this.formatLinkDate(createdCandidate);
    } catch (e) {
      return createdCandidate.toString();
    }
  }

  /**
   * Return a readable expiry date for the link (prefers expiryDateObj, expiryDate)
   */
  private getExpiryDateFromLink(link: any): string {
    if (!link) return '';
    const expiryCandidate = link.expiryDateObj || link.expiryDate || null;
    if (!expiryCandidate) return '';
    try {
      return this.formatLinkDate(expiryCandidate);
    } catch (e) {
      return expiryCandidate.toString();
    }
  }


  public onLinkSelectionChange(event: any): void {
    const linkId = event.target.value;
    if (linkId) {
      const selected = this.upcomingLinks.find(l => l._id === linkId);
      if (selected) this.selectLink(selected);
    } else {
      this.selectedLink = null;
      this.selectedLinkId = '';
      this.feed.linkId = '';
      this.feed.facilityId = '';
      this.feed.linkName = '';
      this.feed.title = '';
      this.feed.content = '';
      this.createdAt = moment(new Date()).format('DD/MM/YYYY');
    }
  }

  private applyTargetGroups = (evt: any) => {
      const targetIds = Array.isArray(evt.targetGroupIds) ? evt.targetGroupIds : [];

      // Clear previous selections
      this.selectedGroupList = [];
      this.feed.groups = [];

      if (!Array.isArray(this.groupList) || this.groupList.length === 0) {
        this.selectedCriteria = " "
        return;
      }
      // Mark checked state on groupList and build selectedGroupList
      this.groupList.forEach(g => {
        if (targetIds.indexOf(g._id) !== -1) {
          g.checked = true;
          this.selectedGroupList.push(g);
        } else {
          g.checked = false;
        }
      });

      // Ensure uniqueness and populate feed.groups with ids
      this.selectedGroupList = _.uniqBy(this.selectedGroupList, '_id');
      this.feed.groups = this.selectedGroupList.map(g => g._id);
      this.selectedCriteria = "Specific Groups"
    };

  public selectLink(link: any) {
    this.selectedLink = link;
    this.selectedLinkId = link._id;

    // Always prefer expiryDate
    this.createdAt = moment(new Date()).format('DD/MM/YYYY');
    this.feed.linkId = link._id;
    this.feed.facilityId = link._id;
    this.feed.linkName = link.name || link.title;
    this.feed.ctaEnabled = link.ctaEnabled || false;
    this.feed.ctaLink = link.ctaLink || '';
    this.feed.ctaText = link.ctaText || '';
    this.feed.title = `${link.name || link.title}`;
    this.feed.content = this.getLinkDescription(link);
    this.feed.broadcastLink = this.getBoradcastLink(link)
    this.validationErrors.eventError = '';

    const targetIds = Array.isArray(link.targetGroupIds) ? link.targetGroupIds : [];

    // If groups already loaded, apply immediately; otherwise load groups then apply
    if (Array.isArray(targetIds) && targetIds.length > 0) {
      this.applyTargetGroups(link);
    } else {
      this.selectedCriteria = ""
      this.feed.groups = [];
      this.criteria.specificGroup = false;
      this.ideal = true;
      this.feed.sendToAllGroups = false;
    }

  }

  private getBoradcastLink(link) {
    if (link.ctaEnabled === true) {
      const ctaLink = link.ctaLink && link.ctaLink.trim()
        ? link.ctaLink.trim()
        : '';
      return ctaLink
    } else {
      return ''
    }
  }
  private getLinkDescription(link: any): string {
    if (!link) return '';
    const parts: string[] = [];

    // Notes / description
    if (link.notes && link.notes.trim()) {
      parts.push(link.notes.trim());
    }

    // Expiry Date
    // const expiry = link.expiryDateObj || link.expiryDate || null;
    // if (expiry) {
    //   parts.push(`Expiry: ${this.formatLinkDate(expiry)}`);
    // }

    // CTA (optional)
    if (link.ctaEnabled === true) {
      const ctaText = link.ctaText && link.ctaText.trim()
        ? link.ctaText.trim()
        : 'Click Here';
      const ctaLink = link.ctaLink && link.ctaLink.trim()
        ? link.ctaLink.trim()
        : '';
      parts.push(`CTA: ${ctaText}`);
      if (ctaLink) {
        parts.push(`Link: ${ctaLink}`);
      }
    }

    // Price if Fee Payment
    const type = (link.linkType || '').toString().trim().toLowerCase();
    if (type === 'fee payment' || type === 'feepayment') {
      parts.push(`Price: ${this.getLinkPrice(link)}`);
    }

    return parts.join('\n\n');
  }

  private getLinkPrice(link: any): string {
    if (link && link.activityCharges && link.activityCharges.member) {
      const m = link.activityCharges.member;
      if (m.enabled && m.amount && parseFloat(m.amount) > 0) {
        const sym = m.currencySymbol || '$';
        let price = parseFloat(m.amount);
        if (link.isGSTApplicable && link.GSTValue > 0) {
          price += price * (link.GSTValue / 100);
        }
        return `${sym}${price.toFixed(2)}`;
      }
    }
    return 'Free';
  }

  public formatLinkDate(dateString: string): string {
    if (!dateString) return '';
    try {
      return moment(dateString).format('DD/MM/YYYY');  // or DD/MM/YYYY if that’s your desired display
    } catch (e) {
      return dateString.toString();
    }
  }



  public formatLinkTime(timeString: string): string {
    if (!timeString) return '';
    try {
      const parts = timeString.split(':');
      const hours = parseInt(parts[0], 10);
      const minutes = parts[1] || '00';
      const ampm = hours >= 12 ? 'PM' : 'AM';
      const displayHours = hours % 12 || 12;
      return `${displayHours}:${minutes} ${ampm}`;
    } catch (e) {
      return timeString;
    }
  }

  public getLinkOpenTime(link: any): string {
    return link && link.timings && link.timings.openTime ? link.timings.openTime : '';
  }

  public getLinkCloseTime(link: any): string {
    return link && link.timings && link.timings.closeTime ? link.timings.closeTime : '';
  }

  public getLinkCapacity(link: any): number {
    if (!link) return 0;
    return link.maxBookingsPerSlot || link.capacity || link.maxCapacity || 0;
  }

  displayLinkCapacity(link: any): string {
    if (!link) return '';
    const cap = this.getLinkCapacity(link);
    if (cap >= 999999) return 'Unlimited';
    return cap.toString();
  }

  public getCapacityLabel(link: any): string {
    if (!link) return '';
    const cap = this.getLinkCapacity(link);
    if (cap === 0) return 'No booking limit';
    if (cap === 999999) return 'Unlimited bookings';
    const cur = link.currentBookings || 0;
    return `(${cur}/${cap} booked)`;
  }

  public getCapacityPercentage(link: any): number {
    if (!link) return 0;
    const cap = this.getLinkCapacity(link);
    if (cap === 0 || cap === 999999) return 0;
    const cur = link.currentBookings || 0;
    const pct = (cur / cap) * 100;
    return Math.max(0, Math.min(100, pct));
  }

  public getAvailableSlots(link: any): number {
    if (!link) return 0;
    const max = this.getLinkCapacity(link);
    if (max === 0) return 0;
    const cur = link.currentBookings || link.bookedSlots || 0;
    return Math.max(0, max - cur);
  }

  public refreshLinks(): void {
    this.upcomingLinks = [];
    this.loadUpcomingLinks();
  }

  public createNewLink() {
    this.router.navigate(['/addlink']);
  }

  public homeScreen(): void {
    this.router.navigate(['/']);
  }

  public goToFeed(confirmed?: boolean): void {
    if (confirmed === true || confirmed === undefined) {
      this.resetForm();
      this.router.navigate(['/feed']);
    }
  }

  public goToLinks(): void {
    this.router.navigate(['/links']);
  }

  registerTypeBroadcast() {
    this.messageEvent.on().subscribe(message => { this.shouldSlide = message; });
  }

  emitTypeBroadcast() { this.signInEvent.fire('block'); }
  emitTypeLoaderBroadcast() { this.loaderEvent.fire(false); }
  emitOpenFrameEvent() { this.openFrameEvent.fire(false); }

  getGroupListByVendor() {
    let vendorObj = { vendorId: this.getVendorId() };
    this.appService.getListOfGroup(vendorObj).then((result: any) => {
      if (result.status === 'SUCCESS') {
        this.groupList = result.groups;
      }
    });
  }

  uploadFile(event, alertImagePopUpObj) {
    this.loaderEvent.fire(false);
    this.fileUrl = event.target.files[0];
    let input = event.target;
    let file = input.files[0];
    let that = this;
    let reader = new FileReader();
    if (file) {
      if (file.name.indexOf('.jpg') > 0 || file.name.indexOf('.png') > 0 || file.name.indexOf('.bmp') > 0
        || file.name.indexOf('.jpeg') > 0 || file.name.indexOf('.tiff') > 0) {
        this.readFile(file, reader, (result) => {
          that.filesToUpload = result;
          that.loaderEvent.fire(true);
        });
      } else {
        that.loaderEvent.fire(true);
        that.alertMessage = CONSTANT_MESSAGES.IMAGE_ERROR;
        that.popUpMessage = that.alertMessage;
        that.popupTitle = 'Invalid File';
        that.cancleButton = false;
        if (alertImagePopUpObj && alertImagePopUpObj.showChildModal) {
          alertImagePopUpObj.showChildModal();
        }
      }
    } else {
      this.loaderEvent.fire(true);
    }
  }

  readFile(file, reader, callback) {
    reader.onload = () => { callback(reader.result); };
    reader.readAsDataURL(file);
  }

  removeImage() {
    this.filesToUpload = '';
    this.feed.file = '';
    if (this.fileUploadInputVariable) {
      this.fileUploadInputVariable.nativeElement.value = '';
    }
  }

  sendFeed(popupObj, backPopUpObj) {
    try {
      if (!this.validateFeed(popupObj)) {
        return;
      }

      // prepare feed arrays safely (avoid pushing inside filter)
      this.feed.groups = (this.selectedGroupList || []).map((g: any) => g._id).filter(Boolean);
      this.feed.members = (this.selectedMemberList || []).map((m: any) => m.userId).filter(Boolean);

      this.loaderEvent.fire(false);

      const form_data = new FormData();
      form_data.append('title', this.feed.title || '');
      form_data.append('content', this.feed.content || '');
      form_data.append('type', 'LINK_BROADCAST');
      form_data.append('vendorId', this.getVendorId() || '');
      form_data.append('linkId', this.feed.linkId || '');
      form_data.append('facilityId', this.feed.facilityId || '');
      form_data.append('linkName', this.feed.linkName || '');
      form_data.append('groups', (this.feed.groups || []).toString());
      form_data.append('sendToAllMembers', (this.feed.sendToAllMembers || false).toString());
      form_data.append('members', (this.feed.members || []).toString());
      // only append file when present
      if (this.fileUrl) {
        form_data.append('file', this.fileUrl);
      }
      form_data.append('clubName', this.clubName || '');
      form_data.append('clubImageUrl', this.vendor ? this.vendor.clubImageUrl : '');
      form_data.append('sendToAllGroups', (this.feed.sendToAllGroups || false).toString());
      form_data.append('systemUserId', this.getVendorId() || '');
      form_data.append('token', (this.vendor ? this.vendor.token : '') || '');

      const sendOnDate = this.createValidSendOnDate();
      form_data.append('sendOn', sendOnDate);

      const validTillDate = this.createValidTillDate();
      form_data.append('validTill', validTillDate);

      const appVersion = localStorage.getItem('appVersion');
      if (appVersion) form_data.append('appVersion', appVersion.toString());
      form_data.append('deviceType', (CONSTANT_VALUES.DEVICE_TYPE).toString());

      // CTA fields
      form_data.append('ctaEnabled', (this.feed.ctaEnabled || false).toString());
      form_data.append('ctaLink', (this.feed.ctaLink || '').toString());
      form_data.append('ctaText', (this.feed.ctaText || '').toString());
      form_data.append('broadcastLink', (this.feed.broadcastLink || '').toString());

      console.log('Prepared feed data:', this.feed, form_data);
      // call service
      this.feedService.sendFeed(form_data).then((result: any) => {
        this.loaderEvent.fire(true);
        // handle different shapes of response robustly
        if (!result) {
          this.popUpMessage = 'No response from server. Please try again.';
          this.popupTitle = 'Error';
          this.cancleButton = false;
          if (popupObj && popupObj.showChildModal) popupObj.showChildModal();
          return;
        }

        const status = (result.status || '').toString().toUpperCase();
        if (status === 'SUCCESS') {
          this.popUpMessage = result.message || 'Broadcast sent successfully';
          this.popupTitle = 'Success';
          this.cancleButton = false;
          if (backPopUpObj && backPopUpObj.showChildModal) backPopUpObj.showChildModal();
          this.resetForm();
        } else {
          // server returned an error-ish result
          this.popUpMessage = result.message || 'Failed to send broadcast. Please try again.';
          this.popupTitle = 'Error';
          this.cancleButton = false;
          if (popupObj && popupObj.showChildModal) popupObj.showChildModal();
        }
      }).catch((error) => {
        this.loaderEvent.fire(true);
        this.popUpMessage = (error && error.message) ? error.message : 'Network error: Failed to send broadcast. Please try again.';
        this.popupTitle = 'Error';
        this.cancleButton = false;
        if (popupObj && popupObj.showChildModal) popupObj.showChildModal();
      });
    } catch (e) {
      console.error('sendFeed error', e);
      this.loaderEvent.fire(true);
      this.popUpMessage = 'Unexpected error while preparing broadcast.';
      this.popupTitle = 'Error';
      this.cancleButton = false;
      if (popupObj && popupObj.showChildModal) popupObj.showChildModal();
    }
  }

  private createValidSendOnDate(): string {
    try {
      const now = new Date();
      if (isNaN(now.getTime())) return new Date(Date.now()).toISOString();
      return now.toISOString();
    } catch (error) {
      return new Date(Date.now()).toISOString();
    }
  }

  private createValidTillDate(): string {
    try {
      // Prefer a valid link expiry date (expiryDateObj/expiryDate); otherwise fall back to 30 days from now
      if (this.selectedLink) {
        const expiryCandidate = this.selectedLink.expiryDateObj || this.selectedLink.expiryDate || null;
        if (expiryCandidate) {
          try {
            const expiryDate = new Date(expiryCandidate);
            if (!isNaN(expiryDate.getTime())) {
              return expiryDate.toISOString();
            }
          } catch (err) {
            console.error('Error parsing link expiry date:', err);
          }
        }
      }

      // Fallback: 30 days from now if no expiry date
      const fallback = new Date();
      fallback.setDate(fallback.getDate() + 30);
      return fallback.toISOString();
    } catch (error) {
      const fallback = new Date();
      fallback.setDate(fallback.getDate() + 30);
      return fallback.toISOString();
    }
  }

  validateFeed(popupObj) {
    try {
      let validateFlag = true;
      this.validationErrors = {
        eventError: '',
        titleError: '',
        contentError: '',
        linkError: '',
        recipientError: ''
      };

      if (!this.selectedLink) {
        validateFlag = false;
        this.validationErrors.eventError = 'Please select a link for the broadcast';
        this.popUpMessage = 'Please select a link for the broadcast';
        this.popupTitle = 'Link Required';
        this.cancleButton = false;
        popupObj.showChildModal();
        return validateFlag;
      } else if (!(this.feed.title + '').trim()) {
        validateFlag = false;
        this.validationErrors.titleError = CONSTANT_MESSAGES.ERROR_MESSAGE_SUBJECT;
        this.popUpMessage = CONSTANT_MESSAGES.ERROR_MESSAGE_SUBJECT;
        this.popupTitle = 'Subject Required';
        this.cancleButton = false;
        popupObj.showChildModal();
        return validateFlag;
      } else if (!(this.feed.content + '').trim()) {
        validateFlag = false;
        this.validationErrors.contentError = CONSTANT_MESSAGES.ERROR_MESSAGE_CONTENT;
        this.popUpMessage = CONSTANT_MESSAGES.ERROR_MESSAGE_CONTENT;
        this.popupTitle = 'Content Required';
        this.cancleButton = false;
        popupObj.showChildModal();
        return validateFlag;
      } else if (this.checkUrl()) {
        validateFlag = false;
        this.validationErrors.linkError = CONSTANT_MESSAGES.INVALID_URL;
        this.popUpMessage = CONSTANT_MESSAGES.INVALID_URL;
        this.popupTitle = 'Invalid URL';
        this.cancleButton = false;
        popupObj.showChildModal();
      } else if ((this.selectedGroupList.length === 0) && !this.feed.sendToAllGroups && !this.feed.sendToAllMembers && (this.selectedMemberList.length === 0)) {
        validateFlag = false;
        this.validationErrors.recipientError = CONSTANT_MESSAGES.SELECT_RECIPIENTS_BROADCAST;
        this.popUpMessage = CONSTANT_MESSAGES.SELECT_RECIPIENTS_BROADCAST;
        this.popupTitle = 'Recipients Required';
        this.cancleButton = false;
        popupObj.showChildModal();
        return validateFlag;
      }
      return validateFlag;
    } catch (e) {
      console.log(e);
    }
  }

  actionOnCriteria(para, popupObj) {
    if (this.selectedCriteria !== para) {
      this.selectedCriteria = para;
      this.criteria.allMember = false;
      this.criteria.specificMembers = false;
      switch (para) {
        case 'All Members':
          if (this.memberList.length === 0) {
            this.selectedCriteria = '';
            this.popUpMessage = CONSTANT_MESSAGES.NO_MEMBER_AVAILABLE;
            this.popupTitle = 'No Members';
            this.cancleButton = false;
            popupObj.showChildModal();
          } else {
            this.selectedMemberList = [];
            this.setChecked = [];
            this.unSelectSpecificGroup();
            this.criteria.allMember = true;
            this.feed.sendToAllMembers = true;
          }
          break;
        case 'Specific Members':
          if (this.memberList.length > 0) {
            this.unSelectSpecificGroup();
            this.feed.sendToAllMembers = false;
            this.criteria.specificMembers = true;
            this.ideal = false;
            this.cancelForReset = true;
            this.pagination(this.pageOptions, 1);
          } else {
            this.selectedCriteria = '';
            this.popUpMessage = CONSTANT_MESSAGES.NO_MEMBER_AVAILABLE;
            this.popupTitle = 'No Members';
            this.cancleButton = false;
            popupObj.showChildModal();
          }
          break;
        case 'All Groups':
          if (this.groupList.length === 0) {
            this.selectedCriteria = '';
            this.popUpMessage = CONSTANT_MESSAGES.NO_GROUP_AVAILABLE;
            this.popupTitle = 'No Groups';
            this.cancleButton = false;
            popupObj.showChildModal();
          } else {
            this.unSelectSpecificMembers();
            this.feed.groups = [];
            this.selectedGroupList = [];
            this.criteria.allGroup = true;
            this.feed.sendToAllGroups = true;
          }
          break;
        case 'Specific Groups':
          if (this.groupList.length > 0) {
            this.unSelectSpecificMembers();
            this.cancelForReset = true;
            this.criteria.specificGroup = true;
            this.ideal = false;
          } else {
            this.selectedCriteria = '';
            this.popUpMessage = CONSTANT_MESSAGES.NO_GROUP_AVAILABLE;
            this.popupTitle = 'No Groups';
            this.cancleButton = false;
            popupObj.showChildModal();
          }
          break;
      }
    }
    this.isopen = false;
  }

  pagination(pageOptions, pageNo) {
    this.currentPage = 1;
    if (pageOptions) this.pageOptions = pageOptions;
    let vendorObject = {
      'vendorId': this.getVendorId(),
      perPage: this.pageOptions.noOfPageItem,
      pageNumber: pageNo ? pageNo : this.pageOptions.currentPage,
      filters: []
    };
    if (this.AddNewMemberFlag) vendorObject.filters = [{ type: 'exclude', values: this.setChecked }];
    if ((this.search + '').trim()) {
      vendorObject['filters'].push({ type: 'search', values: this.search });
      if (this.tableVariable) this.tableVariable.currentPage = pageNo ? pageNo : this.pageOptions.currentPage;
    }
    this.getMemberListByVendor(vendorObject);
  }

  getMemberListByVendor(vendorObj) {
    try {
      this.loaderEvent.fire(false);
      let that;
      this.appService.getListOfMember(vendorObj).then((result: any) => {
        if (result.status === 'SUCCESS') {
          this.memberList = result.memberList.filter(member => !member.isBlackListed);
          this.totalSizeOfList = result.total;
          this.noMemberAvailable = (result.total > 0);
          this.memberList.map(function (mem) {
            mem.enable = !mem.isBlackListed ? 'Active' : 'Inactive';
            mem.signedUpOn = moment(mem.signedUpOn).format('DD/MM/YYYY');
            return mem;
          });
        }
        this.setCheckedList();
        that = this;
        if (this.selectedMemberList.length > 0) {
          this.memberList = this.memberList.filter(function (rec: any) {
            if (_.some(that.selectedMemberList, rec)) rec.isChecked = true;
            return rec;
          });
          this.setAllMemberCheck.fire(true);
        }
        this.loaderEvent.fire(true);
      }).catch((err) => {
        this.popUpMessage = err;
        this.loaderEvent.fire(true);
      });
    } catch (e) { console.log(e); }
  }

  selectSpecificMembers(memberObj: any) {
    try {
      if (memberObj.isChecked) {
        this.selectedMemberList.push(memberObj);
        this.selectNewMembers.push(memberObj);
      } else {
        _.remove(this.selectedMemberList, (n) => n.userId === memberObj.userId);
        _.remove(this.selectNewMembers, (n) => n.userId === memberObj.userId);
        if (this.tableVariable && this.tableVariable.allInGroup) this.tableVariable.allInGroup = false;
      }
      this.selectedMemberList = _.uniq(this.selectedMemberList);
    } catch (e) { console.log(e); }
  }

  selectAllMembers(memberList: any) {
    try {
      let that = this;
      this.setUserIdListTOSendFeed();
      if (!this.tableVariable.allInGroup) {
        for (let rec of this.memberList) {
          _.remove(that.selectedMemberList, function (n) { return n.isChecked === false; });
          _.remove(that.selectNewMembers, function (n) { return n.isChecked === false; });
        }
      }
    } catch (e) { console.log(e); }
  }

  setUserIdListTOSendFeed() {
    for (let mem of this.memberList) {
      if ((this.selectedMemberList.indexOf(mem) < 0)) this.selectedMemberList.push(mem);
      if ((this.selectNewMembers.indexOf(mem) < 0)) this.selectNewMembers.push(mem);
    }
    this.selectedMemberList = _.uniq(this.selectedMemberList);
    this.selectNewMembers = _.uniq(this.selectNewMembers);
  }

  public reset() { this.resetForm(); }

  public resetForm() {
    try {
      this.setFlagOnReset();
      this.exp = false;
      this.search = '';
      if (this.tableVariable) this.tableVariable.allInGroup = false;
      this.unSelectSpecificGroup();
      this.selectedCriteria = '';
      this.criteria.specificGroup = false;
      this.unSelectSpecificMembers();
      this.groupList.map(function (rec: any) {
        if (rec.checked === true) rec.checked = false;
        return;
      });
      this.selectNewMembers = [];
      this.pagination(this.pageOptions, 1);

      this.selectedLink = null;
      this.selectedLinkId = '';
      this.feed.linkId = '';
      this.feed.linkName = '';
      this.feed.title = '';
      this.feed.content = '';
      this.feed.broadcastLink = '';
      this.feed.groups = [];
      this.feed.members = [];
      this.feed.sendToAllMembers = false;
      this.feed.sendToAllGroups = false;

      this.filesToUpload = '';
      this.fileUrl = null;
      if (this.fileUploadInputVariable) this.fileUploadInputVariable.nativeElement.value = '';

      this.validationErrors = {
        eventError: '',
        titleError: '',
        contentError: '',
        linkError: '',
        recipientError: ''
      };

      this.ideal = true;
      this.cancelForReset = false;
      this.addGroupFlagCancel = false;
      this.AddNewMemberFlag = false;
    } catch (e) { console.log(e); }
  }

  public goToComposeMessage(popUpObj: any) {
    if (this.checkMemberListForSelection()) {
      if (this.tableVariable) this.tableVariable.allInGroup = false;
      this.setFlagOnReset();
      this.AddNewMemberFlag = false;
    } else {
      this.popUpMessage = CONSTANT_MESSAGES.SELECT_MEMBER_FEED;
      this.popupTitle = 'Selection Required';
      this.cancleButton = false;
      if (popUpObj && popUpObj.showChildModal) popUpObj.showChildModal();
    }
    this.selectedMemberList = _.uniq(this.selectedMemberList);
  }

  public showSelectedItems(popupObj: any, ViewSelectedpopUpObj: any, ViewSelectedGroupPopUpObj: any): void {
    if (this.selectedCriteria === 'Specific Members' && this.selectedMemberList.length > 0) {
      this.showSelectedMembersWithCustomModal(ViewSelectedpopUpObj);
    } else if (this.selectedCriteria === 'Specific Groups' && this.selectedGroupList.length > 0) {
      this.showSelectedGroupsWithCustomModal(ViewSelectedGroupPopUpObj);
    } else {
      this.popUpMessage = 'No recipients have been selected yet.';
      this.popupTitle = 'No Selection';
      if (popupObj && popupObj.showChildModal) popupObj.showChildModal();
    }
  }

  private showSelectedMembersWithCustomModal(ViewSelectedpopUpObj: any): void {
    this.popupTitle = `Selected Members (${this.selectedMemberList.length})`;
    if (ViewSelectedpopUpObj && ViewSelectedpopUpObj.showChildModal) ViewSelectedpopUpObj.showChildModal();
  }

  private showSelectedGroupsWithCustomModal(ViewSelectedGroupPopUpObj: any): void {
    this.popupTitle = `Selected Groups (${this.selectedGroupList.length})`;
    if (ViewSelectedGroupPopUpObj && ViewSelectedGroupPopUpObj.showChildModal) ViewSelectedGroupPopUpObj.showChildModal();
  }

  public removeFromSelection(member: any): void {
    if (!member) return;
    _.remove(this.selectedMemberList, (n) => n.userId === member.userId);
    _.remove(this.selectNewMembers, (n) => n.userId === member.userId);
    if (this.selectedMemberList.length === 0 && this.selectedCriteria === 'Specific Members') {
      this.selectedCriteria = '';
      this.criteria.specificMembers = false;
      this.ideal = true;
    }
    this.updateMemberCheckboxes();
  }

  public removeGroupFromSelection(group: any): void {
    if (!group) return;
    if (_.some(this.selectedGroupList, group)) {
      _.remove(this.selectedGroupList, (n) => n._id === group._id);
    }
    if (this.selectedGroupList.length === 0 && this.selectedCriteria === 'Specific Groups') {
      this.selectedCriteria = '';
      this.criteria.specificGroup = false;
      this.ideal = true;
    }
    this.getGroupListByVendor();
  }

  private updateMemberCheckboxes(): void {
    if (this.memberList && this.memberList.length > 0) {
      this.memberList.forEach(member => {
        member.isChecked = this.selectedMemberList.some(selected => selected.userId === member.userId);
      });
      if (this.tableVariable) this.setCheckedList();
    }
  }

  saveGroupList(popupObj) {
    let flag = false;
    for (let group of this.groupList) {
      if (group.checked) {
        if (!_.some(this.selectedGroupList, group)) this.selectedGroupList.push(group);
      } else {
        if (_.some(this.selectedGroupList, group)) {
          _.remove(this.selectedGroupList, function (n) { return n._id === group._id; });
        }
      }
    }
    for (let group of this.groupList) {
      if (group.checked) { flag = true; break; }
    }
    this.selectedGroupList = _.uniq(this.selectedGroupList);
    if (!flag) {
      this.popUpMessage = CONSTANT_MESSAGES.SELECT_Group_FEED;
      this.popupTitle = 'Selection Required';
      this.cancleButton = false;
      popupObj.showChildModal();
    } else {
      this.criteria.specificGroup = false;
      this.cancelForReset = false;
      this.ideal = true;
      this.AddNewMemberFlag = false;
      this.addGroupFlagCancel = false;
    }
  }

  setCheckedList() {
    try {
      let flagAllChecked = true;
      for (let mem of this.memberList) if (!mem.isChecked) { flagAllChecked = false; break; }
      if (this.tableVariable) this.tableVariable.allInGroup = flagAllChecked;
    } catch (e) { console.log(e); }
  }

  addRecipants() {
    this.exp = false;
    this.search = '';
    this.selectedMemberList = _.uniq(this.selectedMemberList);
    let that = this;
    this.ideal = false;
    this.cancelForReset = false;
    switch (this.selectedCriteria) {
      case 'Specific Members':
        this.setChecked = [];
        this.selectNewMembers = [];
        for (let item of this.selectedMemberList) this.setChecked.push(item.userId);
        this.criteria.specificMembers = true;
        this.addGroupFlagCancel = false;
        this.AddNewMemberFlag = true;
        this.pagination(this.pageOptions, 1);
        break;
      case 'Specific Groups':
        this.ideal = false;
        this.addGroupFlagCancel = true;
        this.cancelForReset = false;
        this.AddNewMemberFlag = false;
        this.criteria.specificGroup = true;
        this.groupList = this.groupList.filter(function (rec: any) {
          if (!_.some(that.selectedGroupList, rec)) return rec;
        });
        break;
    }
  }

  removeMemberList() {
    this.criteria.specificMembers = false;
    let that = this;
    for (let member of this.memberList) {
      for (let item of this.selectedMemberList) {
        if (member.userId === item.userId) {
          member.isChecked = true;
        } else {
          member.isChecked = false;
        }
        break;
      }
    }
    this.AddNewMemberFlag = false;
  }

  removeGroupFromSelectionOnCancel() {
    this.AddNewMemberFlag = false;
    this.addGroupFlagCancel = false;
    this.cancelForReset = false;
    this.ideal = true;
  }

  checkMemberListForSelection() {
    return this.selectNewMembers.some(item => item.isChecked);
  }

  expand() {
    if (!this.search) this.exp = !this.exp;
    if (this.selectedCriteria == 'Specific Members') this.pagination(this.pageOptions, 1);
  }

  setFlagOnReset() {
    this.criteria.specificMembers = false;
    this.isopen = false;
    this.ideal = true;
    this.cancelForReset = false;
  }

  unSelectSpecificMembers() {
    this.feed.sendToAllMembers = false;
    this.selectedMemberList = [];
    this.setChecked = [];
  }

  unSelectSpecificGroup() {
    this.feed.sendToAllGroups = false;
    this.feed.groups = [];
    this.selectedGroupList = [];
  }

  checkUrl() {
    let regEx = /^http(s)?:\/\/(www\.)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
    if (this.feed.broadcastLink) {
      return !regEx.test(this.feed.broadcastLink);
    }
    return false;
  }

  public canSendBroadcast(): boolean {
    return this.selectedLink &&
      this.feed.title.trim() &&
      this.feed.content.trim() &&
      this.selectedCriteria &&
      (this.feed.sendToAllMembers ||
        this.feed.sendToAllGroups ||
        this.selectedMemberList.length > 0 ||
        this.selectedGroupList.length > 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/facility/link/broadcast/link-broadcast.component.ts